/**
 * Clamp a toast body to a legible length. A long agent message (a full drafted
 * reply, a multi-paragraph summary) must never dump its entire text into the
 * transient pop-up — trim on a word boundary and append an ellipsis. Pure; the
 * CSS line-clamp below is the visual belt-and-suspenders, this guards the string.
 */
export function clampToastMessage(text: string, max = 200): string {
  const trimmed = text.trim();
  if (trimmed.length <= max) return trimmed;
  const slice = trimmed.slice(0, max);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace > max * 0.6 ? slice.slice(0, lastSpace) : slice;
  return `${cut.replace(/[\s.,;:!?-]+$/, '')}…`;
}
